import { Injectable } from "@angular/core";
import { Http, Response } from "@angular/http";
import { APPLICATION_SCOPE_TYPES, ITCIApplicationAuth, ITCIFlogoTesterService, ITCIHybridDbConnection, SERVICE_URLS } from "@tci/common";
import { Observable } from "rxjs";
import { NgUserService } from "../../ng-shared/ng-services/ng-user.service";

@Injectable()
export class BaseHybridConnectionService {
    constructor(
        private http: Http,
        private userService: NgUserService
    ) {}

    public getDBServiceStatus(): Observable<ITCIHybridDbConnection> {
        const url = `${SERVICE_URLS.DB_SERVICE}`;
        return this
            .http
            .get(url)
            .map(res => {
                return res && res.json() || null;
            })
            .catch(error => {
                console.log(`Error is getting DB Service status`, error);
                throw error;
            });
    }

    public enableDBService(accessKey: string = ""): Observable<any> {
        let url = `${SERVICE_URLS.DB_SERVICE}`, data = {};
        if (accessKey !== "") {
            url += `/${accessKey}`;
            data = {
                "accessKey": accessKey
            };
        }
        return this
            .http
            .post(url, data)
            .map(res => res.json())
            .catch(error => {
                console.log(`Error in enabling DB Service`, error);
                throw error;
            });
    }

    public enableHybridDBService(): Observable<any> {
        const url = `${SERVICE_URLS.HYBRID_DB_SERVICE}`;
        return this
            .http
            .post(url, {})
            .map(res => res.json())
            .catch(error => {
                console.log(`Error in enabling Hybrid DB Service`, error);
                throw error;
            });
    }

    public disableDBService(): Observable<any> {
        const url = `${SERVICE_URLS.DB_SERVICE}`;
        return this
            .http
            .delete(url)
            .map((res) => res.json())
            .catch(error => {
                console.log(`Error in disabling DB Service`, error);
                throw error;
            });
    }

    public getAccessKeys(): Observable<string[]> {
        const url = `${SERVICE_URLS.TIB_TUNNEL}/accesskeys`;
        return this
            .http
            .get(url)
            .map((res: Response) => res && res.json() || null)
            .catch(error => {
                console.log(`Error getting Tib tunnel access keys`, error);
                throw error;
            });
    }

    public updateAccessKey(accessKey: string): Observable<any> {
        const url = `${SERVICE_URLS.DB_SERVICE}/${accessKey}`;
        return this
            .http
            .put(url, accessKey)
            .map((res) => res.json())
            .catch(error => {
                console.log(`Error in updating access key`, error);
                throw error;
            });
    }

    public getUserAuthForDBService(): Observable<ITCIApplicationAuth> {
        return this.userService.getAuthForFunction(APPLICATION_SCOPE_TYPES.APP);
    }

    public getFlogoTesterServices(): Observable<ITCIFlogoTesterService> {
        const url = `${SERVICE_URLS.FLOGO_TESTER}`;
        return this
            .http
            .get(url)
            .map(res => res.json())
            .catch(error => {
                console.log(`Error is getting Flogo Tester Services`, error);
                throw error;
            });
    }

    public enableFlogoTesterServices(): Observable<any> {
        const url = `${SERVICE_URLS.FLOGO_TESTER}`;
        return this
            .http
            .post(url, {})
            .map(res => res.json())
            .catch(error => {
                console.log(`Error in enabling Flogo Tester Services`, error);
                throw error;
            });
    }

    public disableFlogoTesterServices(): Observable<any> {
        const url = `${SERVICE_URLS.FLOGO_TESTER}`;
        return this
            .http
            .delete(url)
            .map((res) => res.json())
            .catch(error => {
                console.log(`Error in disabling Flogo Tester Services`, error);
                throw error;
            });
    }

}
